
  import {
    Component,
    Vue
  } from "vue-property-decorator";
  import CollapseItem from '@/components/collapse.vue';
  import PageFooter from '@/components/page-footer.vue';
  import Switch from '@/components/switch.vue';
  import SkuList from './components/sku-list.vue';
  import UploadImg from '@/components/upload-img.vue';
  import SelectRefundAddress from './components/select-refund-address.vue';
  import Message from '@/components/message.vue';
	import previewImg from '@/components/previewImg.vue';
  import {imgHost,maxspecifications} from '@/utils/config';
  import {
    getOssToken
  } from '@/api/user'
  import {
    supplierList,
    productInfo,
    createProduct,
    updateProduct,
    productUnitList
  } from '@/api/supplier';
  import {
    providerLogisticsTplList,
    getProviderReturnLogistics,
    freightSettlementTemplatefreightSettlementTemplateList
  } from '@/api/logistics'
  import {
    getUserInfo
  } from "@/utils/storage";

  import cutarrow from '@/components/cutarrow.vue';
  @Component({
    name: 'product-detail',
    components: {
      CollapseItem,
      PageFooter,
      'slz-switch': Switch,
      SkuList,
      UploadImg,
      SelectRefundAddress,
      'slz-message': Message,
      previewImg,
      cutarrow
    }
  })
  export default class ProductDetail extends Vue {
    private url = imgHost
    private type = this.$route.query.type;
    private id = +this.$route.query.id;
    private isPass = +this.$route.query.isPass;
    private search = ''
    private chooseTab = 0;
    private arrowlist = [
      {value:0,label:'基本信息'},
			{value:1,label:'商品图文详情'},
    ]
    private ProductInfo = {}
    private units: any = [];
    private selectVal = '';
    private isPageLoading = false;
    private selectList = [{
        label: '内容',
        value: '值'
      }, {
        label: '内容2',
        value: '值2'
      }
    ]
    private pickerOptions: any = {
      shortcuts: [{
        text: '今天',
        onClick(picker: any) {
          picker.$emit('pick', new Date());
        }
      }, {
        text: '昨天',
        onClick(picker: any) {
          const date = new Date();
          date.setTime(date.getTime() - 3600 * 1000 * 24);
          picker.$emit('pick', date);
        }
      }, {
        text: '一周前',
        onClick(picker: any) {
          const date = new Date();
          date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
          picker.$emit('pick', date);
        }
      }]
    }
    private list: any = []
    private formData: any = {
      sku:[],
      ProductName: '', // (string, optional): 商品名称,
      ProductUnitId: '', // (int): 单位Id,
      SpecTitle: '', // (string, optional): 规格1标题,
      SpecTitle2: '', // (string, optional): 规格2标题,
      SpecTitle3: '', // (string, optional): 规格3标题,
      FreightTemplateId: '', // (int): 物流模板Id,
      ProviderReturnAddressId: '', // (int): 退货地址Id,
      ProductAuthPic: [], // (Array[string], optional): 产品资质授权书,
      ProductSixFaceImgUrl: [], // (Array[string], optional): 产品六面图,
      ProductThumbImgUrl:[], // (string, optional): 产品封面图--遮罩,
      Video:[], // (string, optional): 视频,
      ImgUrl: [], // (Array[string], optional): 商品主图,
      NoWatermarkImgUrl: [],
      Details: [], // (Array[string], optional): 商品详情页,
      ProductSpecList: [], // (Array[ProviderProductSpecToSave], optional): 商品规格信息,
      SpecImgSelectLeve: '', // (int): 规格图选择的规格层级
      // ProductType:0,
			IsIncludedSubmitOrderInfo:false,//是否计入交单信息
			ProductMixInfoList:[],
			IsShareStock:false,
			SellPoint:'',
			ProductInfo:[],
			SpecBacthDataList:[],
      AgriculturalProductSalesReport:[],
      NonFarmProductSalesReport:[],
      LegitimateUser:[],
      HolderOfTradeMark:[],
      Trademark:'',
      TradeMarkRegistrationCertificate:[],
      AuthorizationDocuments:[],
      SupplementaryMaterial:[],
      ProductNo:'',
      FreightSettlementTemplateId:'',
      TemplateName:'',
      FreightSettlementType:1,
      DetailList:[]
    }
    private formRule: any = {
      'ProductName': '请填写商品名',
      'ProductUnitId': '请选择商品单位',
      // 'FreightTemplateId': '请选择物流模板',
      'ProviderReturnAddressId': '请选择退货地址',
      //   'retail_check_time': '请输入零售审核时长',
      //   'zd_check_time': '请输入VIP审核时长',
      //   'hx_check_time': '请输入VIC审核时长',
      //   'lc_check_time': '请输入SVIC审核时长'
    }
    private picRule: any = {
      'ProductThumbImgUrl': '请上传封面图',
      'ImgUrl': '请上传商品主图',
      'Details': '请上传商品详情图',

      // 'ProductAuthPic': '请上传产品资质&授权书',
	    // 'ProductSixFaceImgUrl': '请上传产品六面图',

    }
    private token: any = {}
    private skus: any = [{
      name: '', // 规格名
      list: []
    }]
    private skuDetail: any = []
    private skuNames: string[] = []
    private totalSku: any = {
      Stock: 0,
      Price: 0,
      GroupPrice: 0,
      ProviderSupplyPrice:0,
    }
    private loadingSupplier = false;
    private supplierList: any = [];
    private showSelectRefundAddress = false;
    private selectRA: any = null;
    private showSubmitConfirm = false;
    private logisticsList: any = [];
    private isCover = false;
    
		//最多添加规格数
		private specificationsNum = maxspecifications

		private searchName = ''
		private searchList:any = []
		private searchLoading = false
		private Shared = false
		private SharedDetail:any = []
		private SharedtotalSku:any = []
		private minnum = 0

    private explainShow = false

		private currentUrl = ''
		private showPreview = false
    private fileType = 'image'

    private changeDrag = false

    
		private isButtjoint = false
		private jushuitantips = false



    private activated() {
      this.getLogisticsList();
      if (this.$route.query.id) {
        this.isPageLoading = true;
        this.getInfo();
        // console.log(this.formData.ProductCheckState)
      }
      this.getUnits();
    }
    /**
     * 获取供应商信息
     */
    private get userInfo() {
      // return {}
      return getUserInfo();
    }



    private getSettlementTemplate(e){
      let msg = this.logisticsList.find(v=>v.Id==e)
      // console.log(msg)
      if(msg&&msg.Id){
        this.formData.TemplateName = msg.TemplateName
        this.formData.FreightSettlementType = msg.FreightSettlementType
        this.formData.DetailList = msg.DetailList
      }

    }
    private saveDrag(){
			// console.log(this.formData.sku)
			let sortlist = this.formData.sku.map(v=>v.Sort).sort((a,b)=>{return a-b})
			for(let index in sortlist){
				// console.log(sortlist[index],Number(index)+1)
				if(!sortlist[index]){
					this.$message.error('请完善规格的序号值')
					return false
				}
				// else if(sortlist[index]>sortlist.length){
				// 	this.$message.error('规格排序不能大于'+sortlist.length)
				// 	return false
				// }
				else if(sortlist[index]!=(Number(index)+1)){
					this.$message.error('层级必须是从1开始的连续的序号')
					return false
				}
			}
			this.formData.sku = this.formData.sku.sort((a,b)=>{return a.Sort-b.Sort})
			this.formData.sku.map((v,i)=>{
				v.sku_info&&v.sku_info.length&&v.sku_info.map(x=>{
					if(x.pic_url){
						// console.log(x,i)
						this.formData.SpecImgSelectLeve = i
						return 
					}
				})
			})
      this.skuNames = this.formData.sku.map(v=>v.sku_name)
			// console.log(this.formData.sku,this.formData.SpecImgSelectLeve)
			this.changeDrag = false
			this.bunch({})
		}
		private cancelDrag(){
			this.formData.sku = this.formData.sku.map((v,i)=>{
				v.Sort = i+1
				return v
			})
			this.changeDrag = false
		}

    private reviewsample(name){
			this.currentUrl = 'http://cdn2024.shiwuzone.com/routuan/image/' + name + '.jpg'
			this.showPreview = true
			this.fileType = 'image'
    }
    private downloadtemplate(name){
			let filename = ''
			if(name=='AgriculturalProductSalesReport'){
				filename = '产品销售声明（销售方、生产方）.docx'
			}else if(name == 'NonFarmProductSalesReport'){
				filename = '产品销售声明（经销商）.docx'
			}else if(name == 'LegitimateUser'){
				filename = '产品销售声明（合法使用者）.docx'
			}else if(name == 'HolderOfTradeMark'){
				filename = '产品销售声明（商标持有者）.docx'
			}else if(name == 'AuthorizationDocuments'){
				filename = '品牌授权书.docx'
			}
			let url = 'https://xsoss2016.oss-cn-hangzhou.aliyuncs.com/routuan/file/'+encodeURIComponent(filename)
			let a = document.createElement('a')
			a.href = url
			a.download = filename
			a.style.display = 'none'
			document.body.appendChild(a)
			a.click()
			document.body.removeChild(a)
    }

    private showSelectRefund() {
      this.showSelectRefundAddress = true;
    }

    deactivated() {
      if (this.$route.matched[0].path === '/product') {
        // console.log('销毁')
        this.$destroy();
      }
    }


    
		private pushProductInfo(){
			this.formData.ProductInfo.push({
				InfoName:'',
				InfoContent:''
			})
		}

		private delProductInfo(i){
			this.formData.ProductInfo.splice(i,1)
		}

    
		private changeShared(e){
			this.formData.IsShareStock = e
			this.bunch({})
		}
    
		private getIsIncludedSubmitOrderInfo(val){
			this.formData.IsIncludedSubmitOrderInfo = val
			this.bunch({})
		}

		private async bunch(obj:any){
				let arr = JSON.parse(JSON.stringify(this.formData.sku))
				let num=0
				let list = []
				if(arr.length==1){
					arr.map(v=>{
						v.sku_info.map(x=>{
							list.push([x])
						})
					})
				}
				// console.log(list,'list')
				//规格只有一个的时候不会走这个循环 所以上面直接赋值就行
				for(let i=0;i<arr.length-1;i++){
					if(i+1>=arr.length) break
					let a:any = this.combo(arr[i],arr[i+1],i)
					// console.log(a,'a')
					//拼接完成之后将前一个数据替换掉 再与后面还没拼接的数据继续拼接
					arr.splice(i+1,1,{sku_info:a})
					num++
					if(num>=arr.length-1){
						list = a
					}
				}
				let detaillist = list.map(v=>{
					let data:any = {
						ImgUrl:v.find(x=>x.pic_url)?.pic_url || '',
						Id: 0,
						preorder_num: 0,
						sales_amount: 0,
						core_price: '', //VIC价
						lc_price: '', //SVIC价
						SellCount: 0, //销量
						Price: '', //原价
						Stock: '', //库存
						GroupPrice: '', //团购价
						ThirdRolePrice: '', //VIP价
						SpreadPrice: '', //差价
						ProviderSupplyPrice: '', //拾物Zone价
						Count:'',
						IsCanSubmitOrder:true,
						ProductSpecNo:''
					}
					v.map((x,i)=>{
						let key = 'SpecValue'+(i==0?'':i+1)
						data[key] = x.sku_value
						data.classKey = ''
						data.classKey += x.classKey

						//只有一个规格会有数据
						// console.log(this.formData.IsShareStock)
						if(this.formData.IsShareStock){
							data.Count = x.Count || data.Count
							// console.log(data)
							data.IsCanSubmitOrder = x.IsCanSubmitOrder || data.IsCanSubmitOrder
						}
					})
					// console.log(data,12)
					return data
				})
				if(obj.changetype==1){
					this.skuDetail = await this.oldlistChangetitle(obj,detaillist)
				}else{
					this.skuDetail = await this.assignment(detaillist,obj)
				}
				if(this.formData.IsIncludedSubmitOrderInfo){
					let SharedDetail:any = []
					SharedDetail = await this.getshardlist(this.skuDetail,obj)
					this.SharedDetail = SharedDetail
				}
				// console.log(this.skuDetail)
				// console.log(this.SharedDetail.map(v=>v.map(x=>x.isShowNumInput)),111)
		}
		//如果设置了共享库存 则需要改变商品详情的数组结构
		private getshardlist(list:any,obj:any){
			let sku = JSON.parse(JSON.stringify(this.formData.sku))
			// console.log(sku)
			// console.log(Math.min(...sku[0].sku_info.map(v=>v.Count)))
			// this.SharedtotalSku = []
			let minnum = Math.min(...sku[0].sku_info.map(v=>v.Count||0))
			this.minnum = minnum
			let newlist:any = []
			sku[0].sku_info.map((v,i)=>{
				let data:any = []
				list.map(x=>{
					if(x.SpecValue==v.sku_value){
						// console.log(v)
						x.Count = v.Count
						x.IsCanSubmitOrder = v.IsCanSubmitOrder || false
						x.isShowNumInput = (minnum!=0&&minnum==v.Count)
						// console.log(x)
						data.push(x)
					}
				})
				if(!this.SharedtotalSku[i]){
					let batch:any = {
						SpecBacthStock: '', //库存
						SpecBacthSellCount:'',//数量
						SpecBacthPrice: '', //原价
						SpecBacthGroupPrice: '', //团购价
						SpecBacthSpreadPrice: '', //差价
						SpecBacthThirdRolePrice: '', //VIP价
						SpecBacthProviderSupplyPrice: '', //拾物Zone价
					}
					this.SharedtotalSku.push(batch)
				}
				newlist.push(data)
			})

			return newlist
		}
		//如果是修改规格名称 则不会改变表格内的数量 所以按顺序赋一遍值就行了
		private oldlistChangetitle(obj:any,list:any){
			let oldlist = JSON.parse(JSON.stringify(this.skuDetail))
			return list.map((v,i)=>{
				for(let key in v){
					//除了规格型号的值 全替换成原来的数据
					if(key.indexOf('SpecValue')==-1){
						v[key] = oldlist[i][key]
					}
				}
				return v
			})
		}
		//每次传入两个数组互相拼接
		private combo(arr1:any,arr2:any,num:number){
			let newarr = []
			arr1.sku_info.map(v=>{
				arr2.sku_info.map(x=>{
					if(num==0){//第一次的时候v是个字符串
						newarr.push([v,x])
					}else{//第一次之后就是一个字符串数组
						newarr.push([...v,x])
					}
					
				})
			})
			return newarr
		}

		private assignment(detaillist:any,msg:any){
			let sku = JSON.parse(JSON.stringify(this.formData.sku))
			let oldlist = JSON.parse(JSON.stringify(this.skuDetail))
			let list:any = []
			// console.log(detaillist,123)
      // console.log(oldlist,this.skuDetail)
			// console.log(sku)
			detaillist.map(async (j:any,ind:number)=>{
				// console.log(this.findoldVal(detaillist,j),ind)
				let obj = await this.findoldVal(detaillist,j)
				// console.log(obj,j)
				//如果在原数据中没有找到老的数据 对象为空
				//因为新增的数据跟老数据没有太大差别 在下一次新增时 上一个新增的会成为老数据 所以不用id判断
        // console.log(this.totalSku)
				if(Object.keys(obj).length==0||msg.IsDel){
						let ThirdRolePrice = this.totalSku.ThirdRolePrice //VIP价
						let SpreadPrice = this.totalSku.SpreadPrice //差价
						let core_price = parseFloat(((ThirdRolePrice || 0) - (SpreadPrice || 0)).toFixed(2)) //VIC价
						let lc_price = parseFloat(((core_price || 0) - (SpreadPrice || 0)).toFixed(2)) //SVIC价
						let oldmsg = this.getpicurl(j)
						// console.log(oldmsg,'oldmsg')
						let data:any = {
							ImgUrl:j.ImgUrl,
							Id:0,
							preorder_num: 0,
							sales_amount: 0,
							core_price: core_price, //VIC价
							lc_price: lc_price, //SVIC价
							SellCount: 0, //销量
							Price: this.totalSku.Price, //原价
							Stock: this.totalSku.Stock, //库存
							GroupPrice: this.totalSku.GroupPrice, //团购价
							ThirdRolePrice: this.totalSku.ThirdRolePrice, //VIP价
							SpreadPrice: this.totalSku.SpreadPrice, //差价
							ProviderSupplyPrice:this.totalSku.ProviderSupplyPrice||'', //拾物Zone价
							Count:j.Count,
							IsCanSubmitOrder:j.IsCanSubmitOrder,
						}
            // console.log(sku)
						sku.map((v,i)=>{
							let key = 'SpecValue'+(i==0?'':i+1)
							data[key] = j[key]
						})
						// console.log(data,'data')
						list.push(data)
				}else{
					obj.ImgUrl = j.ImgUrl
					obj.Count = j.Count
					obj.IsCanSubmitOrder = j.IsCanSubmitOrder
          // console.log(j,'j')
        // console.log(obj,this.totalSku)
				// 	console.log(obj,j,'else')
					list.push(obj)
				}
			})

			return list
		}
		//新增型号的时候会有没有改变的数据
		private findoldVal(newlist:any,newval:any){
			let oldlist = JSON.parse(JSON.stringify(this.skuDetail))
			let sku = JSON.parse(JSON.stringify(this.formData.sku))
			// console.log(newval,oldlist,newval.SpecValue,newval.SpecValue2)
			let oldvalue:any = {}
			old:for(let i = 0;i<oldlist.length;i++){
				let num = 0
				sku:for(let x =0;x<sku.length;x++){
					let key = 'SpecValue'+(x==0?'':x+1)
					// console.log(key)
					if(oldlist[i][key]===newval[key]){
						num+=1
						continue sku
					}
				}
				if(num == sku.length){
					oldvalue = oldlist[i]
					break old
				}
			}
			return oldvalue
		}
		//这里找到对应数据对应的规格信息 查找图片
		private getpicurl(newval:any){
			// console.log(newval)
			let sku = JSON.parse(JSON.stringify(this.formData.sku))
			let list:any = []
			for(let i=0;i<sku.length;i++){
				for(let y=0;y<sku[i].sku_info.length;y++){
					let key = 'SpecValue'+(i==0?'':i+1)
					if(newval[key]===sku[i].sku_info[y].sku_value){
						list.push(sku[i].sku_info[y])
						break
					}
				}
			}
			return list
		}

    /**
	 * 获取单位列表
	 */
    private async getUnits(){
      try{
        const res:any = await productUnitList({});
        this.units = res.Result;
      }catch(err){
        console.log(err)
      }
    }

    private toBack() {
      this.$router.go(-1)
    }

    private toLogistics(id) {
      this.$router.push({
        path: '/logistics/settleTemplatedetail',
        query:{
          Id:id
        }
      })
    }

    // 数据是否为空
    private isEmpty() {
      for (let key in this.formData) {
        if (this.formRule[key] && !this.formData[key]) {
          // console.log(this.formData,1)
          this.$message({
            type: 'warning',
            message: this.formRule[key]
          })
          return true
        }
      }
      if(this.formData.ProductCheckState!=5&&this.formData.ProductCheckState!=6){
        for (let key in this.formData) {
          if (this.picRule[key] && !this.formData[key].length) {
            this.$message({
              type: 'warning',
              message: this.picRule[key]
            })
            return true
          }
        }
      }
      
			if(this.formData.IsShareStock){
				for(let item of this.formData.sku[0].sku_info){
					// console.log(item.Count)
					if(item.Count < 1 || item.Count > 999 || item.Count != parseInt(item.Count)){
						this.$message({
							type: 'warning',
							message: '请输入正确的数量'
						})
						return true
					}
				}
			}
      return false;
    }

    /**
     * 添加规格
     */
		private addSkus() {
			// if(this.isLook){

			// 	return
			// } 
			if (this.formData.sku.length >= this.specificationsNum) {
				// let list = ['一','二','三','四','五']
				this.$message(`最多添加${this.specificationsNum}个规格`);
				return false
			}
			this.formData.sku.push({
				sku_name: '',
				sku_info: [],
        Sort:this.formData.sku.length+1,
			})
			this.isCover = true;
		}

    /**
     * 删除规格
     */
    private deleteSkus(obj: any) {
      this.formData.sku.splice(obj.index, 1);
			this.calcSku(obj)
      this.bunch({IsDel:true})
    }

    /**
     * 计算生成sku
     */
    private calcSku(obj: any) {
		  // console.log(obj)
      if (obj.type && obj.type === 'delete') {
        this.isCover = true;
      }
	    this.formData.SpecImgSelectLeve = obj.picIndex;
      const list = obj.list;
      const skuList: any = [];
      const skuName: string[] = [];
      let tableListLength = 1
      let skuItem = {}
      this.formData.sku = []
      list.length && list.map((item: any, index: number) => {
				if (item.sku_name) {
					skuName.push(item.sku_name);
				}
			})
			this.formData.sku = list;
      this.skuNames = skuName;
      // }
      this.bunch(obj)
    }

    // 获取token
    private async getToken() {
      try {
        const res: any = await getOssToken({})
        this.token = {
          AccessKeySecret: res.access_key_secret,
          OSSAccessKeyId: res.access_key_id,
          SecurityToken: res.security_token
        }
      } catch (e) {
        console.error('getOssToken ===>', e)
      }
    }

    // 改变全部价格
    private changAllPricd(e: any, type: string) {
      let two = /^\d+(\.\d{1,2})?$/
			if(Number(this.totalSku[type])<0 || !two.test(this.totalSku[type])){
				this.totalSku[type] = ''
				return 
			}
      // this.skuDetail.map((item: any) => {
      //   item[type] = this.totalSku[type];
      //   console.log(item[type],this.totalSku[type],type)
      //   if (type === 'Stock' || type === 'Price' || type === 'GroupPrice') {
      //     // item.core_price = parseFloat((item.agent_price - item.price_spread).toFixed(2));
      //     // (+item.core_price < 0 && (item.core_price = 0));
      //     // item.lc_price = parseFloat((item.agent_price - item.price_spread * 2).toFixed(2));
      //     // (+item.lc_price < 0 && (item.lc_price = 0))
      //     console.log(1)
      //   }
      // })
      
      let isConform = false
      // for(let item of this.skuDetail){
      //   item[type] = this.totalSku[type];
      // }
      // if(type === 'ProviderSupplyPrice'){
				// let isConform = false
        // let two = /^\d+(\.\d{1,2})?$/
				for(let item of this.skuDetail){
          // console.log(item)
          item[type] = this.totalSku[type];

          if(type === 'ProviderSupplyPrice'){
            if(!item.ProviderSupplyPrice||item.ProviderSupplyPrice<=0){
              this.$message.error('请输入供货价')
              isConform = true
            }else if(!item.ProviderSupplyPrice||item.ProviderSupplyPrice<=0||item.ProviderSupplyPrice>1000000||!two.test(item.ProviderSupplyPrice)){
              // console.log(item.ProviderSupplyPrice)
              this.$message.error('请输入正确的供货价')
              isConform = true
            }
            if(isConform){
              this.totalSku[type] = ''
              this.skuDetail = this.skuDetail.map((v:any)=>{
                v.ProviderSupplyPrice = ''
                return v
              })
              return
            }
          }
          // console.log(item)
				}
			// }
      if (type === 'preorder_num') {
        this.changePreorderNum();
      }
    }
    private changPricd(e: any, type: string){
      // let two = /^\d+(\.\d{1,2})?$/
      // for(let item of this.skuDetail){
      
      // }
    }

    // 修改预售数量时 计算总数
    private changePreorderNum() {
      this.formData.preorder_num = 0;
      this.skuDetail.map((item: any) => {
        this.formData.preorder_num += (+item.preorder_num || 0)
      })
    }

    // 改变VICSVIC的价格
    private wathhxlc(e: any, index: number) {
      let data: any = this.skuDetail[index]
      if (data.price_spread && data.agent_price) {
        data.core_price = parseFloat((data.agent_price - data.price_spread).toFixed(2));
        (+data.core_price < 0 && (data.core_price = 0))
        data.lc_price = parseFloat((data.agent_price - data.price_spread * 2).toFixed(2));
        (+data.lc_price < 0 && (data.lc_price = 0))
      }
      this.$set(this.skuDetail, index, data);
    }


    // 获取供应商列表
    private async getSupplierList(query: string) {
      if (!query.length) return;
      this.loadingSupplier = true;
      let params: any = {
        page_no: 1,
        page_size: 500,
        state: 0
      }
      if (query) {
        params.keyword = query;
      }
      try {
        const res: any = await supplierList(params);
        this.supplierList = res.Result;
        this.loadingSupplier = false;
      } catch (e) {
        this.loadingSupplier = false;
        console.log('supplierList ===>', e);
      }
    }

    private trimParams() {
      	// console.log(this.skuDetail, this.formData);
	
      this.formData.sku_params = JSON.parse(JSON.stringify(this.skuDetail.map((v,i)=>{
				v.Sort = i
				return v
			})))
      let params: any = JSON.parse(JSON.stringify(this.formData));
      params.Id = this.id || '';
      params.ProductSpecList = this.skuDetail;

      if(params.IsIncludedSubmitOrderInfo){
				params.ProductSpecList = []
				this.SharedDetail.map(v=>{
					v.map(x=>{
						params.ProductSpecList.push(x)
					})
				})
			}else{
				params.ProductSpecList = this.skuDetail.map(v=>{
					if(params.ProductType==1){
						v.Stock = 0
					}
					return v
				})
			}

      //获取图片index
			params.sku.map((v,i)=>{
				v.sku_info&&v.sku_info.length&&v.sku_info.map(x=>{
					if(x.pic_url){
						// console.log(x,i)
						params.SpecImgSelectLeve = i
						return 
					}
				})
			})

      params.ProductMixInfoList = []
      for(let i = 0;i<this.specificationsNum;i++){
        let key = 'SpecTitle'+(i==0?'':i+1)
        params[key] = this.formData.sku[i]?this.formData.sku[i].sku_name : '';
      }
      params.SpecBacthDataList = this.SharedtotalSku

      
      // console.log(params);
      params.ProductThumbImgUrl = params.ProductThumbImgUrl[0];
      params.Video = params.Video&&params.Video.length ? params.Video[0]:'';

      	return params;
    }

    // 提交信息
    private submit() {
		  if (this.isEmpty()) {
        return;
      }
      // console.log('这里拦住了')
      // return
			if(this.isButtjoint){
				this.jushuitantips = true
				return
			}
      this.showSubmitConfirm = true;
    }

    private handleConfirm() {
      
      this.doCreate()
    }

    // 创建商品
    private async doCreate() {
      let params = this.trimParams();
      // console.log(params)
      // return 
      try {
        await createProduct(params)
        this.$message({
          type: 'success',
          message:[5,6].includes(this.formData.ProductCheckState)?'提交成功，请等待复审结果':'创建成功'
        })
        this.toBack()
      } catch (e) {
        console.log(e)
      }
    }

    // 更新商品
    private async doUpdate() {
      let params = this.trimParams();
      try {
        await updateProduct(params)
        this.$message({
          type: 'success',
          message: '修改成功'
        })
        this.toBack();
      } catch (e) {
        console.log(e)
      }
    }

    // 通过id获取退款地址
    private async getRefundAddressByID(id: number) {
      if (!id) {
        this.selectRA = {}
        return
      };
      let params: any = {
        Skip: 0,
        Take: 99999
      }
      try {
        const res: any = await getProviderReturnLogistics(params);
      //  console.log(res.Result.Results,this.formData.ProviderReturnAddressId)
       let selectRA = res.Result.Results.find(v=>v.Id==id)
       if(selectRA&&selectRA.Id){
         this.selectRA = selectRA;
         this.formData.ProviderReturnAddressId = selectRA.Id;
       }
        // console.log(this.selectRA,'selectRA')
      } catch (e) {
        console.log(e)
      }
    }

    private async getInfo() {
      try {
        const res: any = await productInfo({
          Id: +this.$route.query.id
        })
        this.isPageLoading = false;
        const skuMap = {};
        // this.skus = []
        this.formData.sku = [];
        this.skuNames = []
        
				//计算规格类型列表
				for(let i = 0;i<this.specificationsNum;i++){
					let key = 'SpecTitle'+(i==0?'':i+1)
					if(res.Result[key]){
						this.formData.sku.push({
							sku_name: res.Result[key],
							sku_info: [],
							key:Math.random(),
							Sort:i+1
						})
						this.skuNames.push(res.Result[key])
					}
				}
        

        if (!res.Result.NoWatermarkImgUrl?.length){
          res.Result.NoWatermarkImgUrl = res.Result.ImgUrl;
        }

        if (res.Result.ProductSpecList && res.Result.ProductSpecList.length) {
          res.Result.ProductSpecList.forEach((item: any, index: number) => {

            item.core_price = parseFloat((item.ThirdRolePrice - item.SpreadPrice).toFixed(2));
            item.lc_price = parseFloat((item.ThirdRolePrice - item.SpreadPrice * 2).toFixed(2));
            // item.ProviderSupplyPrice = parseFloat((item.ThirdRolePrice - item.SpreadPrice * 3).toFixed(2));
            
						for(let i = 0;i<this.specificationsNum;i++){
							let key = 'SpecValue'+(i==0?'':i+1)
							if(item[key] && this.formData.sku[i]){
								var have = null;
								let haveIndex = -1;
								this.formData.sku[i].sku_info.map((obj: any, index: number) => {
									if (obj.sku_value === item[key]) {
										have = obj;
										haveIndex = index;
									}
								})
								// console.log(item,i,res.Result.SpecImgSelectLeve)
								if (!have) {
									let data = {
										pic_url: '',
										sku_value: item[key],
										sku_id: item.Id,
										sku_ids: [item.Id],
										isNew: false,
										classKey:Math.random(),
                    //只有第一层级的规格才会有
										Count:i==0?item.Count:'',
										IsCanSubmitOrder:item.IsCanSubmitOrder&&i==0?item.IsCanSubmitOrder:false,
									}
									this.formData.sku[i].sku_info.push(data)
									if(i==res.Result.SpecImgSelectLeve){
										// console.log(item)
										this.formData.sku[i].sku_info[this.formData.sku[i].sku_info.length-1].pic_url = item.ImgUrl||''
									}
								}else{
									this.formData.sku[i].sku_info[haveIndex].sku_ids.push(item.Id);
								}
							}
						}
            
          })
        }
        this.isButtjoint = res.Result.IsUserJuShuiTan
        // console.log(this.isButtjoint,'isButtjoint',res.Result.IsUserJuShuiTan)
        this.skuDetail = res.Result.ProductSpecList;
        res.Result.ProductThumbImgUrl = res.Result.ProductThumbImgUrl?[res.Result.ProductThumbImgUrl]:[];
        res.Result.Video = res.Result.Video?[res.Result.Video]:[];


        this.totalSku = {
					Stock:res.Result.SpecBacthStock||'',//库存
					Price:res.Result.SpecBacthPrice||'',//原价
					GroupPrice:res.Result.SpecBacthGroupPrice||'',//团购价
					SpreadPrice:res.Result.SpecBacthSpreadPrice||'',//差价
					ThirdRolePrice:res.Result.SpecBacthThirdRolePrice||'',//VIP价
					ProviderSupplyPrice:res.Result.SpecBacthProviderSupplyPrice||'',//拾物Zone价
				}

        
				this.SharedtotalSku = res.Result.SpecBacthDataList
        for (let item in res.Result){
					this.formData[item] = res.Result[item];
				}
        // console.log(this.formData.sku)
        // console.log(this.totalSku)
        this.formData.ProductUnitId = this.formData.ProductUnitId||''
        this.formData.FreightTemplateId = this.formData.FreightTemplateId||''
        this.formData.ProviderReturnAddressId = this.formData.ProviderReturnAddressId||''
        this.formData.FreightSettlementTemplateId = this.formData.FreightSettlementTemplateId||''
				this.bunch({isInfo:true})
        // console.log(123)
        this.getRefundAddressByID(res.Result.ProviderReturnAddressId)
        // console.log(this.formData.ProductSpecList[0]?.SpecBacthProviderSupplyPrice,'123')
      } catch (e) {
        console.log(e)
      }finally{
        this.isPageLoading = false;

      }
    }

    // 上传图片成功回调
    private uploadSuc(list: any, key: string) {
      this.formData[key] = list
      console.log(this.formData[key],key)
    }

    // 选择退款地址
    private selectRefundAddress(row: any) {
      this.formData.ProviderReturnAddressId = row.Id;
			this.selectRA = row;
			this.showSelectRefundAddress = false
    }


    /**
     * 获取结算模板
     */
    private async getLogisticsList() {
      try {
        const res: any = await freightSettlementTemplatefreightSettlementTemplateList({
          Skip: 0,
          Take: 500
        })
        this.logisticsList = res.Result.Results;
      } catch (err) {
        console.log(err);
      }
    }
  }
